import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { default_avatar } from '../../static/default_design';
import { MobMenu } from '../UiKit/MobMenu';
import { applyDesignTheme, applyYoniBlackBackground, AVATAR_TOKEN_LENGTH, HISTORY_INCLUDE_PENTAS, PENTA_TOKEN_LENGTH, USER_TOKEN_LENGTH } from '../utilsDesign';
import { fetchUsers } from '../utilsSocial';
import { PreloaderHD } from '../UiKit/PreloaderHD';
import { getPentaDesign } from '../utilsPenta';




export const WithPenta = ({ children, bodyContainer, mode = 'hd' }) => {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const navigate = useNavigate();
  const [penta, setPenta] = useState();

  const { pentaId } = useParams();
  const isYoni = mode === 'yoni';

  useEffect(() => {
    if (typeof context.me === 'undefined') return;
    if (context.me && context.pentas == null) return;

    const callbackFail = () => {
      navigate('/404');
    };

    const fetchAvatarData = async () => {
      if (pentaId
        && pentaId.length !== PENTA_TOKEN_LENGTH
        && pentaId.split('-').length
      ) {
        const membersIds = pentaId.split('-').filter(one => one.length === USER_TOKEN_LENGTH);
        const membersIdsAvatars = pentaId.split('-').filter(one => one.length === AVATAR_TOKEN_LENGTH);

        const containsAllMembers = (onePentamembers, membersIds) => {
          // Extract tokens from onePentamembers
          const onePentamemberTokens = onePentamembers.map(member => member.user ? member.user.token : null);

          // Create sets from both arrays to compare
          const membersIdsSet = new Set(membersIds);
          const onePentamemberTokensSet = new Set(onePentamemberTokens);

          // Compare the sets for equality
          if (membersIdsSet.size !== onePentamemberTokensSet.size) {
            return false;
          }

          for (let token of onePentamemberTokensSet) {
            if (!membersIdsSet.has(token)) {
              return false;
            }
          }

          return true;
        };

        const existingPentas = context.pentas ? context.pentas.filter(onePenta => {
          return containsAllMembers(onePenta.members, membersIds);
        }) : [];




        if (existingPentas.length) {
          navigate(isYoni ? `/yoni/p/${existingPentas[0].token}` : `/p/${existingPentas[0].token}`);
        } else {
          // NO EXISTING PENTAS
          const pentaEmpty = {
            unsaved: true,
            my: true,
            count: 2,
            created: "2024-07-08T01:41:19+00:00",
            description: "description",
            members: [],
            name: null,
            permissions: 1,
            token: '',
            pentaDesign: ''
          };


          const pentaAvatars = []
          const avatarPromises = membersIdsAvatars.map(async (oneAvatarId) => {
            const avatar = await context.x.getAvatar(oneAvatarId);
            return {
              user: null,
              avatar: {
                ...avatar,
                my: true
              }
            };
          });
          const pentaAvatarsResolved = await Promise.all(avatarPromises);
          pentaAvatars.push(...pentaAvatarsResolved);

          const emptyUser = {
            user: null,
            avatar: default_avatar
          }

          fetchUsers(membersIds, (members => {
            pentaEmpty.members = [
              ...pentaAvatars,
              ...Object.keys(members).map(oneId => members[oneId])
            ];
            if (pentaEmpty.members.length === 1) {
              pentaEmpty.members = [...pentaEmpty.members, emptyUser]
            }
            // if (pentaEmpty.members.length === 0) {
            //   pentaEmpty.members = [emptyUser, emptyUser]
            // }
            pentaEmpty.token = null;
            pentaEmpty.pentaDesign = getPentaDesign(pentaEmpty);
            setPenta(pentaEmpty);
          }));

        }

      }
    };

    fetchAvatarData();



    if (pentaId && pentaId.length === PENTA_TOKEN_LENGTH) {
      context.x.getPenta(pentaId, setPenta, callbackFail);
    }

  }, [pentaId, context.updatingPenta, context.me, context.pentas == null]);

  useEffect(() => {
    if (!pentaId || pentaId.length !== PENTA_TOKEN_LENGTH || !context.pentas?.length) return;
    const updated = context.pentas.find(one => one.token === pentaId);
    if (updated) {
      setPenta(updated);
    }
  }, [context.pentas, pentaId]);

  useEffect(() => {
    if (HISTORY_INCLUDE_PENTAS && penta?.token && pentaId?.length === PENTA_TOKEN_LENGTH) {
      context.setState.setShowHistory(penta.token);
    }
  }, [penta?.token, pentaId]);

  useLayoutEffect(() => {
    if (!penta) return;
    if (isYoni) {
      // Keep the shared dark starfield look — don't paint HD design type colors.
      applyYoniBlackBackground();
      return;
    }
    const design = penta.pentaDesign || (penta.members?.length >= 2 ? getPentaDesign(penta) : null);
    applyDesignTheme(design);
  }, [penta?.token, penta?.pentaDesign?.type, penta?.members?.length, isYoni]);


  const parameters = {
    penta: penta,
    parentContainer: bodyContainer,
    mode,
  };


  return <>

    {!penta && <PreloaderHD />}

    {Boolean(context.me) && <MobMenu
      penta={penta}
      mode={mode}
      showItems={isYoni
        ? ['people', 'history', 'bodygraphs', 'pentas']
        : undefined}
    />}

    {parameters.penta ? React.cloneElement(children, parameters) : null}
  </>
};
